import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentService } from '../../services/component.service';
import { OverlayService } from '../../services/overlay.service';
import { NewApiHttpService, NewApiResponse } from '../../services/new-api-http.service';
import { AuthService } from '../../services/auth.service';
import { BeeFreeService } from '../../services/beefree.service';
import { forkJoin, Subscription } from 'rxjs';

declare let gtag;
declare const Prism;

@Component({
	selector: 'app-component-snippet',
	templateUrl: './component-snippet.component.html',
	styleUrls: ['./component-snippet.component.scss']
})
export class ComponentSnippetComponent implements OnInit, OnDestroy {
	componentData: any = {};
	email;
	formHeight;
	designedSnippet;
	saving = false;
	sendingText = 'Send Email';
	copyButtonText = 'Copy to Clipboard';
	copyIconText = '';
	isAdmin: boolean;
	imageComponentType = [7, 8, 9, 10, 11, 13, 15, 18, 20, 23, 32, 38, 40, 51, 53, 55];
	isImageComponent: boolean;
	isBeeFree: boolean;
	isBeeFreeHTML: boolean;
	joinedSubscription: Subscription;
	defaultIcon = 'fa fa-exclamation-circle';
	componentExists = true;

	constructor(
		private route: ActivatedRoute,
		private component: ComponentService,
		private overlay: OverlayService,
		private newApiHttpService: NewApiHttpService,
		public auth: AuthService,
		private beeFree: BeeFreeService,
		private router: Router
	) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.isBeeFree = this.beeFree.isBeeFreeAddon();
		this.isBeeFreeHTML = this.beeFree.isBeeFreeHTMLAddon();

		//    this.formHeight = (window.innerHeight - 170) + 'px';
		this.formHeight = 'auto';

		let suportedComponents$ = this.component.getSupportedComponents();
		let componentData$ = this.component.getComponentData(this.route.snapshot.params['componentID']);

		this.joinedSubscription = forkJoin([componentData$, suportedComponents$]).subscribe(
			(results) => {
				const componentDataResult = results[0];
				const suportedComponentsResults = results[1];

				this.componentData = componentDataResult.data;

				this.sendGTag();

				this.component.updateComponentData(componentDataResult.data);

				if (this.componentData.config.type !== 25) {
					this.component.updatePreviewContent(componentDataResult.data.snippet);
				}

				this.designedSnippet = Prism.highlight(componentDataResult.data.snippet, Prism.languages.html);

				const supportedcomponentItem = suportedComponentsResults.data.find((data) => {
					return data.type === this.componentData.config.type;
				});

				this.componentData.icon =
					supportedcomponentItem && supportedcomponentItem.icon ? supportedcomponentItem.icon : this.defaultIcon;

				this.isImageComponent = this.imageComponentType.includes(parseInt(this.componentData.type));

				this.overlay.updateOverlay(false);
			},
			(error) => {
				this.componentExists = false;
				this.overlay.updateOverlay(true, 'Something bad happened. This component does not exist in this account.', 'alert');
			}
		);

		this.overlay.updateRefresh(false);
	}

	ngOnDestroy() {
		this.joinedSubscription.unsubscribe();
	}

	sendEmail() {
		this.saving = true;
		this.sendingText = 'Sending...';

		const headers = new Headers();
		headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
		const data = {
			to: this.email,
			subject: this.componentData.name,
			html: this.componentData.snippet
		};

		this.newApiHttpService.newApiRequestPost('widget/demo', data).subscribe(
			(response: NewApiResponse) => {
				if (response && response.status) {
					this.saving = false;
					this.sendingText = 'Send Email';
					this.overlay.updateOverlay(true, 'Your test email has been sent!', 'alert');
				} else {
					this.overlay.updateOverlay(true, response.message, 'alert');
				}
			},
			(error) => this.overlay.updateOverlay(true, error, 'alert')
		);
	}

	sendToBeeFree() {
		const messageData = {
			type: 'html',
			value: {
				html: this.componentData.snippet,
				metadata: {
					componentID: this.componentData.id
				}
			}
		};
		this.beeFree.sendMessage(messageData, 'onSave');
	}

	cancelBeeFree() {
		this.beeFree.cancelAddon();
	}

	sendToBeeFreeImage() {
		const snippetFragment = new DOMParser().parseFromString(this.componentData.snippet, 'text/html');
		let imgTags = snippetFragment.getElementsByTagName('img');
		let linkTags = snippetFragment.getElementsByTagName('a');
		let messageData = {
			type: 'image',
			value: {
				src: imgTags[0].src,
				metadata: {
					componentID: this.componentData.id
				}
			}
		};

		if (linkTags.length) {
			messageData.value['href'] = linkTags[0].href;
		}

		if (imgTags[0].alt) {
			messageData.value['alt'] = imgTags[0].alt;
		}
		this.beeFree.sendMessage(messageData, 'onSave');
	}

	resetCopyText(originalText, type) {
		if (type == 'copyIconText') {
			setTimeout(() => (this.copyIconText = originalText), 6000);
		} else if (type == 'copyButtonText') {
			setTimeout(() => (this.copyButtonText = originalText), 6000);
		}
	}

	sendGTag() {
		const befreeAddonText = this.isBeeFree ? ' - Beefree Addon' : '';
		const titleText = `DynamicMail Creator - Component Snippet - Widget type: ${this.componentData.config.desc} - Widget ID: ${this.route.snapshot.params['componentID']}${befreeAddonText}`;
		gtag('event', 'page_view', {
			page_path: this.router.url,
			page_title: titleText
		});
	}
}
